import React from 'react';

// Countdown of the challenge validity. Calls `onExpire` once when it reaches zero, and always
// clears its interval on unmount.
class Timer extends React.Component {
    constructor(props) {
        super(props);
        this.state = { time: {}, seconds: props.duration };
        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
    }
    _isMounted = false;

    secondsToTime(secs) {
        const safe = Math.max(0, secs || 0);
        const hours = Math.floor(safe / (60 * 60));
        const divisorForMinutes = safe % (60 * 60);
        let minutes = Math.floor(divisorForMinutes / 60);
        let seconds = Math.ceil(divisorForMinutes % 60);
        if (minutes < 10) {
            minutes = `0${minutes}`;
        }
        if (seconds < 10) {
            seconds = `0${seconds}`;
        }
        return { h: hours, m: minutes, s: seconds };
    }

    componentDidMount() {
        this._isMounted = true;
        this.setState({ time: this.secondsToTime(this.state.seconds) });
        this.startTimer();
    }

    componentWillUnmount() {
        this._isMounted = false;
        clearInterval(this.timer);
    }

    startTimer() {
        if (this.timer === 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown() {
        if (!this._isMounted) {
            return;
        }
        const seconds = this.state.seconds - 1;
        this.setState({ time: this.secondsToTime(seconds), seconds });
        if (seconds <= 0) {
            clearInterval(this.timer);
            if (this.props.onExpire) {
                this.props.onExpire();
            }
        }
    }

    render() {
        return (
            <div>
                Temps restant <span style={{ color: '#28558A', fontWeight: 'bold' }}>{this.state.time.m} : {this.state.time.s}</span>
            </div>
        );
    }
}

export default Timer;
